//
// Scroll Top
//
var fn_scroll_top = function () {

    var btn = $('.js-scroll-to-top');
    var vheight = $(window).height();
    var myLimit = (Math.floor($(window).scrollTop() / vheight)+1) * vheight;

    $(window).scroll(function() {
        if ($(window).scrollTop() > myLimit) {
            btn.addClass('show');
        } else {
            btn.removeClass('show');
        }
    });

    btn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop:0}, '300');
    });

};
